(function() {
    var ua = navigator.userAgent.toLowerCase();
    var isMobile = /iphone|ipad|android/.test(ua);

    var viewportContent = isMobile ? 'width=980' : 'width=device-width, initial-scale=1';

    var viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
        viewportMeta = document.createElement('meta');
        viewportMeta.name = 'viewport';
        document.head.appendChild(viewportMeta);
    }

    viewportMeta.content = viewportContent;
})();